// Static filter options for Payment Integrity pages

import { DropdownOption } from '../types/piFilters.types';

/**
 * Generate dynamic time period options for Payment Integrity
 * Matches the same logic as CommonComponents/GlobalFilter/config.tsx getPaymentIntegrityDates()
 */
export const getPITimePeriodOptions = (): Array<{ title: string; value: string; disable: boolean }> => {
  const currentYear = new Date().getFullYear();
  const now = new Date();
  const years = [currentYear, currentYear - 1, currentYear - 2, currentYear - 3];
  const janYears = [currentYear - 1, currentYear - 2, currentYear - 3, currentYear - 4];
  const isJan = now.getMonth() === 0;
  const dataToMap = isJan ? janYears.slice(0, 3) : years.slice(0, 4);

  return dataToMap.map((year, index) => {
    if (index === 0) {
      const first = new Date(year, 0, 1);
      let last: Date;
      if (year === currentYear) {
        last = now.getMonth() > 0 ? new Date(currentYear, now.getMonth(), 0) : now;
      } else {
        last = new Date(year, 11, 31);
      }
      return {
        title: `${last.toLocaleString('default', { month: 'short' })} YTD (${formatDate(first)} - ${formatDate(last)})`,
        value: `${formatDate(first)}-${formatDate(last)}`,
        disable: false,
      };
    } else {
      return {
        title: year.toString(),
        value: year.toString(),
        disable: false,
      };
    }
  });
};

const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = (1 + date.getMonth()).toString().padStart(2, '0').replace(/(^|-)+/g, '$1');
  const day = date.getDate().toString().padStart(2, '0').replace(/(^|-)+/g, '$1');
  return `${month}/${day}/${year}`;
};

export const PI_CLAIM_TYPE_OPTIONS: DropdownOption[] = [
  { name: 'All', value: 'All', disable: false },
  { name: 'Professional', value: 'HCFA (Health Care Finance Administration)', disable: false },
  { name: 'Facility', value: 'UB (Universal Billing)', disable: false },
];

export const PI_SERVICE_TYPE_OPTIONS: DropdownOption[] = [
  { name: 'All', value: 'All', disable: false },
  { name: 'Inpatient', value: 'Inpatient', disable: false },
  { name: 'Outpatient', value: 'Outpatient', disable: false },
];

export const PI_LOB_OPTIONS: DropdownOption[] = [
  { name: 'All', value: 'All', disable: false },
  { name: 'Commercial', value: 'EI', disable: false },
  { name: 'Medicaid', value: 'CS', disable: false },
  { name: 'Medicare', value: 'MR', disable: false },
  { name: 'Individual Exchange', value: 'EXC', disable: false },
];
